import React from 'react';

const renderTextFormVideo = ({ input,funcao,type, placeholder,meta: { touched, error } }) => (

    <div className="communication-message">
                        <div className="author author-with-link author-with-line "></div>
                        <div className="communication-complement-form">
                          <div className="input-group">
                             <input type={type} {...input} className="form-control input-sm" placeholder={placeholder}/>    
                              <span className="input-group-btn"><button className = "btn btn-danger btn-sm" type = "button" onClick={funcao}>X</button></span>
                           </div>
                           <div className="valid-url"></div>
                        </div>
                    </div>

);
export default renderTextFormVideo;
 



// WEBPACK FOOTER //
// ./src/container/renderFormTextVideo.js